import CertifiedDomesticPostageRates from './CertifiedDomesticPostageRates';
import CertifiedInternationalRates from './CertifiedInternationalRates';
import { Stack } from '@mui/material';

const CertifiedPostageRates: React.FC = () => {
  return (
    <Stack direction="column" width="100%" gap={2}>
      <CertifiedDomesticPostageRates />
      <CertifiedInternationalRates />
    </Stack>
  );
};

export default CertifiedPostageRates;
